export default __webpack_public_path__ + "static/FuturaBT-Book-9c1bdb050d4f094b674709d39303d263.woff2";